document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".grid-view-item .variant-swatch").forEach(function (swatch) {
        swatch.addEventListener("click", function () {
            let variantImage = this.getAttribute("data-variant-image");
            let gridItem = this.closest(".grid-view-item");
            let imageElement = gridItem.querySelector(".grid-view-item__image_front");

            if (variantImage && imageElement.src !== variantImage) {
                // Add fade-out effect
                imageElement.style.opacity = "0";

                // Wait for fade-out to complete before changing the image
                setTimeout(() => {
                    imageElement.src = variantImage;
                    imageElement.setAttribute("srcset", variantImage);

                    // Add fade-in effect
                    imageElement.style.opacity = "1";
                }, 100); // Adjust time to match CSS transition
            }
        });
    });
});